var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value && _vm.value.profile)?_c('div',{key:"logo",staticClass:"white rounded-circle header-img-bg",style:({ width: _vm.size, height: _vm.size })},[_c('div',{staticClass:"bg-filter",style:({ backgroundImage: `url(${_vm.value.profile})` })}),_c('img',{attrs:{"src":_vm.value.profile,"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }